<template>
  <div class="youtube-embed">
    <iframe
      v-if="embedUrl"
      class="youtube-embed__iframe"
      :src="embedUrl"
      :width="playerWidth"
      :height="playerHeight"
      :title="`YouTube video ${videoId}`"
      frameborder="0"
      allow="
        accelerometer;
        autoplay;
        clipboard-write;
        encrypted-media;
        gyroscope;
        picture-in-picture;
      "
      allowfullscreen
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    videoId: string;
    playerWidth?: string | number;
    playerHeight?: string | number;
    playerVars?: Record<string, unknown>;
    host?: string;
    mute?: boolean;
  }>(),
  {
    playerWidth: '100%',
    playerHeight: '360',
    playerVars: () => ({ autoplay: false }),
    host: 'https://www.youtube-nocookie.com',
    mute: false,
  }
);

const embedUrl = computed(() => {
  if (!props.videoId) {
    return '';
  }

  const baseHost = props.host.replace(/\/$/, '');
  const params = new URLSearchParams();
  const playerVars =
    props.playerVars && typeof props.playerVars === 'object' ? props.playerVars : {};
  params.set('autoplay', playerVars.autoplay ? '1' : '0');

  if (props.mute) {
    params.set('mute', '1');
  }

  const time = playerVars.time;
  if (typeof time === 'number' && time > 0) {
    params.set('start', String(time));
  }

  return `${baseHost}/embed/${props.videoId}?${params.toString()}`;
});
</script>

<style scoped lang="scss">
.youtube-embed {
  max-width: 100%;

  &__iframe {
    display: block;
    max-width: 100%;
  }
}
</style>
